import { StanjeRobeUnit } from '../types';

export type M2ProductLike = {
  m2PerPiece?: number;
  perPallet?: number;
};

export const m2PerPallet = (product?: M2ProductLike | null): number => {
  const m2 = Number(product?.m2PerPiece || 0);
  const per = Number(product?.perPallet || 0);
  return m2 > 0 && per > 0 ? m2 * per : 0;
};

export const computeM2FromQuantity = (
  quantity: number,
  unit: StanjeRobeUnit,
  product?: M2ProductLike | null
): number => {
  const qty = Number(quantity) || 0;
  if (!qty || !product) return 0;
  const m2PerPiece = Number(product.m2PerPiece || 0);
  const perPallet = Number(product.perPallet || 0);
  if (unit === 'm2') return qty;
  if (unit === 'kom') return qty * m2PerPiece;
  if (unit === 'paleta') return qty * perPallet * m2PerPiece;
  return 0;
};

export const formatM2 = (n: number): string =>
  (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2);

/** Datum u formatu dd/mm/yyyy, npr. 18/06/2026 */
export const formatStanjeRobeDate = (iso?: string): string => {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return iso;
  }
};

/** Tekstualni opis konverzije, npr. "2 paleta × 48.00 m²/pal = 96.00 m²" */
export const conversionBreakdown = (
  quantity: number,
  unit: StanjeRobeUnit,
  product?: M2ProductLike | null
): string | null => {
  if (!product || !quantity) return null;
  const m2pp = Number(product.m2PerPiece || 0);
  const m2pal = m2PerPallet(product);
  if (unit === 'paleta' && m2pal > 0) {
    return `${quantity} paleta × ${formatM2(m2pal)} m²/pal = ${formatM2(quantity * m2pal)} m²`;
  }
  if (unit === 'kom' && m2pp > 0) {
    return `${quantity} kom × ${formatM2(m2pp)} m²/kom = ${formatM2(quantity * m2pp)} m²`;
  }
  if (unit === 'm2') {
    return `${formatM2(quantity)} m²`;
  }
  return null;
};
